"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterObjectByKey = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _isEmpty = require("../is-empty");
/** 过滤或保留对象中指定的字段
 * @description: 过滤或保留对象中指定的字段，并返回一个新的对象
 * @param { Object } obj 需要过滤的对象
 * @param { String | Array } keys 参与过滤掉key值
 * @param { Boolean } filter 【true（默认）: 过滤掉，不保留，false：不过滤掉，保留的key】
 * @return { Object } 返回判断结果
 */
var filterObjectByKey = exports.filterObjectByKey = function filterObjectByKey(obj, keys) {
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if ((0, _isEmpty.isNoEmpty)(obj, true)) return {};
  var newObj = {};
  if ((0, _isEmpty.isEmpty)(keys)) return filter ? {} : obj;
  if (!Array.isArray(keys)) keys = [keys];
  Object.keys(obj).filter(function (key) {
    return filter ? !keys.includes(key) : keys.includes(key);
  }).forEach(function (key) {
    return newObj[key] = obj[key];
  });
  return newObj;
};